import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-magic-uses-fire',
  templateUrl: './magic-uses-fire.component.html',
  styleUrls: ['./magic-uses-fire.component.css']
})
export class MagicUsesFireComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
